import React from 'react';
import { MeasurementsSection, ResultsSection } from '../Sections';
import { AstmPreparationSection, AstmDryMassesSection } from './Sections';
import ids from '../../QestIds';
import { WorksheetRootComponent } from 'Components/Worksheets/Core';

const qestIds = [ids.moistureContent.ASTM_D_2216.rev2019];

let AstmMeasuredMoistureContentWorksheet: WorksheetRootComponent = () => (
  <>
    <AstmPreparationSection />
    <MeasurementsSection />
    <AstmDryMassesSection />
    <ResultsSection />
  </>
);

AstmMeasuredMoistureContentWorksheet.qestIds = qestIds;

export default AstmMeasuredMoistureContentWorksheet;
export { AstmMeasuredMoistureContentWorksheet };
